/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  customButtonContainer: 'customButtonContainer_6e541892',
  icon: 'icon_6e541892',
  themeDarkAltColor: 'themeDarkAltColor_6e541892',
  leftText: 'leftText_6e541892',
  splitter: 'splitter_6e541892',
  button: 'button_6e541892',
  darkerBG: 'darkerBG_6e541892',
};

export = styles;

loadStyles([{"rawString":".customButtonContainer_6e541892{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.icon_6e541892{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;speak:none;font-size:14px;position:relative}.themeDarkAltColor_6e541892{color:"},{"theme":"themeDarkAlt","defaultValue":"#106ebe"},{"rawString":"}.leftText_6e541892{margin-left:6px;font-size:14px;font-weight:400;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":"}.splitter_6e541892{font-size:14px;font-weight:400;color:"},{"theme":"neutralTertiary","defaultValue":"#a6a6a6"},{"rawString":";background:0 0;position:relative;top:-2px;height:40px}.button_6e541892.ms-Button{height:40px;min-width:28px;padding:0 5px}.button_6e541892:hover{background:initial}.darkerBG_6e541892{background:#d0d0d0}"}]);
/* tslint:enable */